<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-12" style="margin-top: 30px">
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-button type="info" size="mini" @click="getData" circle><i class="fa-solid fa-rotate"></i>
            </el-button>
            &nbsp;&nbsp;&nbsp;
            <el-checkbox @change="getData" v-model="item.myData">{{$t('Mənim_hadisələrim')}}</el-checkbox>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <el-input :placeholder="$t('Axtar')" v-model="search"> </el-input>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <el-table  v-loading="loading" :data="
          data.filter(
            (data) =>
              !search ||
              data.claimNumber
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase()) ||
              data.participants
                .toString()
                .toLowerCase()
                .includes(search.toString().toLowerCase())
          )
        " style="width: 100%">
          >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Status')" width="350">
            <template slot-scope="scope">
              <status-label :type="
                scope.row.statusTypeId === 90
                  ? 'goldenrod'
                  : '' || scope.row.statusTypeId === 105
                    ? 'coral'
                    : '' || scope.row.statusTypeId === 120
                      ? 'olive'
                      : '' || scope.row.statusTypeId === 130
                        ? 'greenYellow'
                        : ''
              " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('İş_#')" prop="claimNumber" width="100">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_/_Qiymətləndirici')" prop="techExpertUserName">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs_/_Müştəri_xidməti')" prop="clientServiceUserName" width="230">
          </el-table-column>

          <el-table-column :label="$t('Başlama_tarixi_/_Gün_sayı')" prop="statusStartDate" width="220">
          </el-table-column>

          <el-table-column align="right" fixed="right" width="30">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="text" style="padding: 0 !important">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'edit', row: scope.row }"><i
                      class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'user', row: scope.row }"><i class="fas fa-user"></i>Məsul şəxs
                    seç</el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'finish', row: scope.row }"><i
                      class="fas fa-people-carry"></i>{{$t('Müştəri_xidmətinə_göndər')}}</el-dropdown-item>
                  <el-dropdown-item divided></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <tech-expert-user @refresh-table="getData" ref="user" />
  </div>
</template>

<script>
  import StatusLabel from "../components/StatusLabel.vue";
  import { GetTechExpertPending } from "src/services/common";
  import TechExpertUser from "./TechExpertUser.vue";
  import { FinishTechExpert } from "../../services/claim";
  export default {
    components: {
      StatusLabel,
      TechExpertUser,
    },
    data() {
      return {
        loading: false,
        data: [],
        search: "",
        uid: this.$store.state.user.id,
        item: {
          myData: false,
          type: 2
        }
      };
    },
    methods: {
      handleCommand(command) {
        let item = command.row;
        if (command.action === "edit") this.handleEdit(item.id);
        else if (command.action === "user") this.handleUser(item);
        else if (command.action === "finish") this.handleFinish(item.id);
      },
      handleFinish(id) {
        this.$confirm(this.$t('ş_müştəri_xidmətlərinə_göndərilsin'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "info",
        }).then(() => {
          this.loading = true;
          FinishTechExpert(id, this.uid).then((response) => {
            this.loading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                this.$message({
                  type: "success",
                  message: this.$t('Uğurlu_əməliyyat'),
                });
                this.getData();
              }
            } else {
              this.$message({
                type: "error",
                message: this.$t('Səhv_əməliyyat'),
              });
            }
          });
        });
      },

      handleEdit(id) {
        this.$router.push({
          path: "claim/" + id,
        });
      },
      handleUser(item) {
        this.$refs["user"].edit(item);
      },
      getData() {
        this.loading = true;
        this.item.commandUserId = this.uid;
        GetTechExpertPending(this.item
        ).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;
          }
        });
      },
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>